

import { Recurso } from "lib.common/dist/CleanArch";
import {
    ErrExterno,
} from "lib.common/dist/errorHandler";
import { GestionarCodProdTiendaRepository } from "../../business/repositories/GestionarCodProdTiendaRepository";
import { ProductoTiendaDsKeyModel } from "../models/ProductoTiendaDsKeyModel";
import { GestionarCodProdTiendaDtSource } from "../../business/dataSources/GestionarCodProdTiendaDtSource";
import { AddDeleteCodProdTIendaParams, GetCodProdTIendaParams } from "../../utils/params/CodProdTIendaParams";

export class GestionarCodProdTiendaRepositoryImpl implements GestionarCodProdTiendaRepository<ProductoTiendaDsKeyModel> {
    private readonly dataSourceGql: GestionarCodProdTiendaDtSource;
    constructor(dataSource: GestionarCodProdTiendaDtSource) {
        this.dataSourceGql = dataSource;
    }

    async addCodProductoTienda(input: AddDeleteCodProdTIendaParams): Promise<Recurso<ProductoTiendaDsKeyModel>> {
        try {
            const response = await this.dataSourceGql.addCodProductoTienda(input);

            if (response.isSuccess()) {
                return Recurso.fromData<ProductoTiendaDsKeyModel>(ProductoTiendaDsKeyModel.deserialize(response.data!));
            }
            return Recurso.fromError<ProductoTiendaDsKeyModel>(response.error!);
        } catch (error) {
            return Recurso.fromError<ProductoTiendaDsKeyModel>(new ErrExterno(error as Error));
        }
    }

    async deleteCodProdTienda(input: AddDeleteCodProdTIendaParams): Promise<Recurso<ProductoTiendaDsKeyModel>> {
        try {
            const response = await this.dataSourceGql.deleteCodProdTienda(input);

            if (response.isSuccess()) {
                return Recurso.fromData<ProductoTiendaDsKeyModel>(ProductoTiendaDsKeyModel.deserialize(response.data!));
            }
            return Recurso.fromError<ProductoTiendaDsKeyModel>(response.error!);
        } catch (error) {
            return Recurso.fromError<ProductoTiendaDsKeyModel>(new ErrExterno(error as Error));
        }
    }

    async getCodProdTienda(input: GetCodProdTIendaParams): Promise<Recurso<ProductoTiendaDsKeyModel[]>> {
        try {
            const response = await this.dataSourceGql.getCodProdTienda(input);

            if (response.isSuccess()) {
                return Recurso.fromData<ProductoTiendaDsKeyModel[]>(response.data!.map(ProductoTiendaDsKeyModel.deserialize));
            }
            return Recurso.fromError<ProductoTiendaDsKeyModel[]>(response.error!);
        } catch (error) {
            return Recurso.fromError<ProductoTiendaDsKeyModel[]>(new ErrExterno(error as Error));
        }
    }
}
